export default {
  extra_info: {
    sofort: {
      title: 'Wichtiger Hinweis',
      item_1: 'Unser Softwareanbieter FoodAmigos (Amigo Technologies) ist mit Sofort verbunden',
      item_2: 'Sofort hebt 1 EUR von Ihrem Konto ab und erstattet Ihnen das Geld, um Ihr Konto zu verifizieren',
    },
  },
};
